<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo.length > 0" class="top-banner-area topo-cel">
    <div class="top-banner-content">

      <img
        class="top-banner-image"
        :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem"
        :alt="bannerTopo[0].itiNome"
      />

      <div class="top-banner-overlay">
        <div class="container">
          <div class="row align-items-center h-100">
            <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12">
              <div class="hero-caption hero-caption2">
                <h2>{{ bannerTopo[0].itiNome }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!--  final banner -->

  <!--=== contato ==========-->
  <section class="contact-section">
    <div v-if="contato != ''" class="container">
      <!-- formulario -->
      <div class="row mb-60">
        <div class="col-12">
          <h2 class="contact-title">{{ contato[0].itiNome }}</h2>
        </div>
        <div class="col-lg-8">
          <form class="form-contact contact_form mb-60" method="post" id="contactForm"
            novalidate="novalidate">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <textarea v-model="formulario.mensagem" class="form-control w-100" name="mensagem" id="mensagem" cols="30" rows="9"
                    onfocus="this.placeholder = ''" onblur="this.placeholder = 'Escreva sua mensagem'"
                    placeholder=" Escreva sua mensagem"></textarea>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.nome" class="form-control valid" name="nome" id="nome" type="text" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = 'Seu nome'" placeholder="Seu nome">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.email" class="form-control valid" name="email" id="email" type="email" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = 'E-mail'" placeholder="E-mail">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-mask="'(##) #####-####'" v-model="formulario.telefone" class="form-control" name="telefone" id="telefone" type="text" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = 'Telefone'" placeholder="Telefone">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.assunto" class="form-control" name="assunto" id="assunto" type="text" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = 'Assunto'" placeholder="Assunto">
                </div>
              </div>
            </div>
            <div class="form-group mt-3">
              <button type="submit" @click.prevent="enviaremail()" class="button button-contactForm boxed-btn">Enviar</button>
            </div>
          </form>
        </div>
        <!-- contatos da empresa -->
        <div class="col-lg-3 mar-cont">
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-home"></i></span>
            <div class="media-body">
              <h3>Endereço</h3>
              <p v-html="contato[0].itiResumo1"></p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-tablet"></i></span>
            <div class="media-body">
              <h3>Telefone</h3>
              <p v-html="contato[0].itiResumo2"></p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-email"></i></span>
            <div class="media-body">
              <h3>E-mail</h3>
              <p v-html="contato[0].itiDescricao1"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- mapa -->
      <div class="d-none d-sm-block mb-5 pb-4">
        <iframe
          :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDmXp4J53f9Wt7iHX7dzIn7rHG7yL-EXXo&q=' + contato[0].itiCampoExtra2"
          width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </section>
  <!-- final contato -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'ContatoView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    contato: [],

    formulario: {
      nome: "",
      email: "",
      telefone: "",
      assunto: "",
      mensagem: ""
    }
  }),

  methods: {
    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else if (this.formulario.telefone == '' || this.formulario.telefone == null) {
        this.$mensagemErro('Telefone obrigatório!');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Igor Paper",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiCampoExtra1,
          emailResposta: this.formulario.email,
          textoEmail:
            "Nome: " + this.formulario.nome + "<br>" +
            "E-mail: " + this.formulario.email + "<br>" +
            "Telefone: " + this.formulario.telefone + "<br>" +
            "Assunto: " + this.formulario.assunto + "<br>" +
            "Mensagem: " + this.formulario.mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
              this.$mensagemSucesso("E-mail enviado com sucesso.")
              this.limparFormulario();
            }
          });
      }

    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.telefone = '';
      this.formulario.assunto = '';
      this.formulario.mensagem = '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

  },

  created() {
    this.carregaMetas("Igor Paper empresa localizada Rua: Laudemiro Ramos, 1060 Jd Fernão Dias Mairiporã- Sp - fones 11 99861-5506 / 11 91929-9838", "Contato");

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/15/contatotopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('contato topo banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca contato
    axios.get('/Process/InsInstitucional/institucional/16/contato/0/x')
      .then(response => {
        this.contato = response.data;
        console.log('contato')
        console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>
<style scoped>
.top-banner-area {
  width: 100%;
  overflow: hidden;
}

.top-banner-content {
  position: relative;
  width: 100%;
  height: clamp(180px, 26vw, 420px);
  background: #000;
}

.top-banner-image {
  width: 100%;
  height: 100%;
  /*object-fit: contain; /* mostra a imagem inteira */
  object-position: center;
  display: block;
}

.top-banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
}

.top-banner-overlay .container,
.top-banner-overlay .row {
  height: 100%;
}

.hero-caption2 {
  color: #fff;
}

.hero-caption2 h2 {
  margin: 0;
  color: #fff;
}

/* notebook 1366 */
@media (min-width: 1200px) and (max-width: 1366px) {
  .top-banner-content {
    height: 300px;
  }
}

/* tablet */
@media (max-width: 991px) {
  .top-banner-content {
    height: 240px;
  }
}

/* mobile */
@media (max-width: 767px) {
  .top-banner-content {
    height: 160px;
  }

  .top-banner-image {
    object-fit: cover;
  }

  .hero-caption2 h2 {
    font-size: 22px;
  }
}
</style>